import CommToolContext from 'containers/common/comm_tool_context';
import React, { useEffect, useState } from 'react';
import { getProject, getTeamRoleMembers, getPreforms, getProjectsHazardous } from 'api';
import AssetDetails from 'containers/releaseproj/Asset_Task/Asset_Tab';
import ReleaseReview from 'containers/releaseproj/release_proj_overview';
import ActiveReview from 'containers/startproj/active_proj_overview';
import ClosedReview from 'containers/startproj/closed_proj_overview';
import PreEForm from 'containers/PreEForm';
import ProjectTasks from 'containers/releaseproj/Project_Task';
import { Tabs } from 'antd';
import MeetingNotes from '../../containers/startproj/MeetingNotes';
import JobJournal from '../../containers/startproj/JobJournal';
import Asset from '../../containers/startproj/Asset/Asset';
import Team from '../../containers/startproj/Team';
import ProjectDetailsWrapper from '../../containers/startproj/projectdetails_wrapper';

const { TabPane } = Tabs;

function ProjectTabsList(props) {
  const { project, context, location, history, match } = props;
  const [teamMembers, setTeamMembers] = useState([]);
  const [currentProject, setCurrentProject] = useState(project);
  const [isEnergized, setIsEnergized] = useState([]);
  const [projectTasks, setProjectTasks] = useState([]);
  const [shouldRefreshMeetingNotes, setShouldRefreshMeetingNotes] =
    useState(false);
  const [shouldRefreshTeamMembers, setShouldRefreshTeamMembers] =
    useState(false);
  const [shouldRefreshPreEForms, setShouldRefreshPreEForms] = useState(false);
  const [shouldRefreshAssets, setShouldRefreshAssets] = useState(false);
  const [shouldRefreshProjectTasks, setShouldRefreshProjectTasks] =
    useState(false);
  const [shouldRefreshJobJournals, setShouldRefreshJobJournals] =
    useState(false);
  const [shouldRefreshProject, setShouldRefreshProject] = useState(false);
  const { setActiveProject } = context;
  const [projectHazard, setProjectHazard] = useState([]);

  useEffect(() => {
    setActiveProject(project);
    getEnergizedValue();
    getProjectsHazardousOptions();
  }, []);

  async function getEnergizedValue(){
    let forms = await getPreforms(project.id);
    let isEnergized = false;
    forms.forEach(element => {
        if(element.energized === 'Y'){
            isEnergized = true;
        }
    });
    setIsEnergized(isEnergized);
  }

  async function getProjectsHazardousOptions(){
    const projectHazard = await getProjectsHazardous(project.id, project.bpid);
    setProjectHazard(projectHazard.hazardousOptions)
  }

  async function tabClicked(key) {
    switch (key) {
      case 'overview':
        const teamMembers = await getTeamRoleMembers(project.id);
        setTeamMembers(teamMembers);
        const updatedProject = await getProject(project.id);
        setCurrentProject(updatedProject);
        setActiveProject(updatedProject);
        break;
      case 'projecttasks':
        const updatedProjectTasks = await getProject(project.id);
        setCurrentProject(updatedProjectTasks);
        setActiveProject(updatedProjectTasks);
        setShouldRefreshProjectTasks(true);
        break;
      case 'team':
        setShouldRefreshTeamMembers(true);
        break;
      case 'details':
        setShouldRefreshProject(true);
        const updatedProjectList = await getProject(project.id);
        setCurrentProject(updatedProjectList);
        setShouldRefreshProject(false);
        setActiveProject(updatedProjectList);
        break;
      case 'notes':
        setShouldRefreshMeetingNotes(true);
        break;
      case 'peform':
        setShouldRefreshPreEForms(true);
        const updatedPrjList = await getProject(project.id);
        setCurrentProject(updatedPrjList);
        setActiveProject(updatedPrjList);
        break;
      case 'assetsummary':
        setShouldRefreshAssets(true);
        break;
      case 'journal':
        setShouldRefreshJobJournals(true);
        break;
      default:
        return null;
        break;
    }
  }

  return (
    <CommToolContext.Consumer>
      {(context) => (
        <div className='container-fluid'>
          <h4>
            <b>{currentProject.stationName}</b>
          </h4>
          <Tabs
            defaultActiveKey='overview'
            className='nav-B'
            onChange={tabClicked}
            onTabClick={(key) =>
              history.push({
                pathname: `/${location}/${project.id}/${key}`,
              })
            }
            type='card'
            activeKey={match.params.tabId || 'overview'}
          >
            <TabPane tab='Project Details' key='details'>
              <ProjectDetailsWrapper project={currentProject} setCurrentProject={setCurrentProject} isEnergizedValue={isEnergized} hazardousMaterialsSelected={projectHazard} refreshProject={shouldRefreshProject} setRefreshProject={setShouldRefreshProject} />
            </TabPane>
            <TabPane tab='Asset Summary' key='assetsummary'>
              {(() => {
                switch (location) {
                  case 'release':
                  case 'active':
                  case 'closed':
                    return (
                      <Asset
                        project={currentProject}
                        refreshAssets={shouldRefreshAssets}
                        setRefreshAssets={setShouldRefreshAssets}
                      />
                    );
                  default:
                    return null;
                }
              })()}
            </TabPane>
            <TabPane tab='Team' key='team'>
              <Team
                project={currentProject}
                status={location}
                refreshTeam={shouldRefreshTeamMembers}
                setRefreshTeam={setShouldRefreshTeamMembers}
                context={context}
              />
            </TabPane>
            <TabPane tab='Project Overview' key='overview'>
              {(() => {
                switch (location) {
                  case 'release':
                    return (
                      <ReleaseReview
                        project={currentProject}
                        context={context}
                        teamMembers={teamMembers}
                        status={location}
                        projectBackButton='Undo'
                      />
                    );
                  case 'active':
                    return (
                      <ActiveReview
                        project={currentProject}
                        context={context}
                        teamMembers={teamMembers}
                        status={location}
                      />
                    );
                  case 'closed':
                    return (
                      <ClosedReview
                        project={currentProject}
                        context={context}
                        teamMembers={teamMembers}
                        status={location}
                      />
                    );
                  default:
                    return null;
                }
              })()}
            </TabPane>
            <TabPane tab='Meeting Notes' key='notes'>
              <MeetingNotes
                project={currentProject}
                status={location}
                history={history}
                refreshNotes={shouldRefreshMeetingNotes}
                setRefreshNotes={setShouldRefreshMeetingNotes}
              />
            </TabPane>
            <TabPane tab='Project Tasks' key='projecttasks'>
              <ProjectTasks
                project={currentProject}
                history={history}
                context={context}
                status={location}
                refreshProjectTasks={shouldRefreshProjectTasks}
                setRefreshProjectTasks={setShouldRefreshProjectTasks}
              />
            </TabPane>
            <TabPane tab='Asset Tasks' key='assettasks'>
              <AssetDetails project={currentProject} context={context} />
            </TabPane>
            <TabPane tab='Pre-Energization' key='peform'>
              <PreEForm
                project={currentProject}
                context={context}
                status={location}
                refreshPreEForms={shouldRefreshPreEForms}
                setRefreshPreEForms={setShouldRefreshPreEForms}
              />
            </TabPane>

            <TabPane tab='Job Journal' key='journal'>
              <JobJournal
                project={currentProject}
                status={location}
                refreshJobJournals={shouldRefreshJobJournals}
                setRefreshJobJournals={setShouldRefreshJobJournals}
                history={history}
              />
            </TabPane>
          </Tabs>
        </div>
      )}
    </CommToolContext.Consumer>
  );
}

export default ProjectTabsList;
